import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';

export class WebpackTranslateLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
        return fromPromise(import(`../assets/i18n/${lang}.json`));
    }
}
